import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  RecurringListScreen,
  type RecurringView,
} from '@/features/accounting-recurring/recurring-list-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/recurring')({
  validateSearch: (search: Record<string, unknown>) => ({
    view: typeof search.view === 'string' ? search.view : 'all',
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_recurring.view'))
      throw redirect({ to: '/accounting' })
  },
  component: () => <RecurringListScreen view={Route.useSearch().view as RecurringView} />,
})
